import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"];

  goToAnchor() {
    if (window.innerWidth > 767) {
      window.location.href = '#grading'
    } else {
      window.location.href = '#blockchain'
    }
  };
}